export const EMPTY_OBJECT = {};

export const FORM_ID = 'contact-form';
export const CONSENT_COOKIE_NAME = 'consent_status';

export const RADIO_TG_LINK = 'https://t.me/astonit';
export const ASTON_INSTAGRAM_LINK = 'https://www.instagram.com/aston.it/';
export const ASTON_YOUTUBE_LINK = 'https://www.youtube.com/@astonlive2023';
export const ASTON_VK_LINK = 'https://vk.com/aston.company';
export const PRICE_1C_LINK = 'https://1c.ru/ftp/pub/pricelst/price_1c.zip';
export const TRAINEE_TG_LINK = 'https://t.me/aston_trainee';
export const TRAINEE_VK_LINK = 'https://vk.com/aston_trainee';

export const DEFAULT_BORDER = '1.6px solid';
export const THIN_BORDER = '1px solid';
export const DEFAULT_BORDER_RADIUS = { mobile: '24px', laptop: '48px' };
export const DEFAULT_TRANSITION = 'all .3s';

export const HEADER_BREAKPOINT = 'xxl';
export const SHUBIN_HEADER_BREAKPOINT = 'xxl';
export const HEADER_HEIGHTS = { mobile: '52px', tablet: '88px', mg: '102px' };
export const GREETINGS_GAP = { mobile: '180px', tablet: '200px', laptop: '253px' };

export const DISABLE_SCROLLBAR_STYLE = {
  '&::-webkit-scrollbar': { display: 'none' },
  msOverflowStyle: 'none',
  scrollbarWidth: 'none',
};
